import { useEffect, useState } from "react";
import { Check, Truck } from "@phosphor-icons/react";
import { billing } from "@/lib/api";

export function usePlans() {
  const [data, setData] = useState(null);
  useEffect(() => { billing.plans().then(setData).catch(() => setData({ plans: [], trial_days: 14 })); }, []);
  return data;
}

const FEATURES = ["Unlimited loads & VIN records", "Pickup + delivery inspections", "Signatures, GPS & timestamps", "Location Memory alerts", "Handoff PDF reports"];

export default function PlanCards({ plans, currentId, action, dark }) {
  return <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4">
    {plans.map((p, i) => {
      const current = currentId === p.id;
      return <div key={p.id} data-testid={`plan-${p.id}`}
        className={`relative flex flex-col p-5 border-2 ${current ? "border-accent" : dark ? "border-white/15" : "border-border"} ${dark ? "bg-white/5" : "bg-white"}`}>
        {i === 1 && <span className="absolute -top-3 left-5 bg-accent text-accent-foreground eyebrow px-2 py-0.5">Most popular</span>}
        <div className="flex items-center gap-2"><Truck size={22} weight="duotone" className={dark ? "text-accent" : "text-primary"}/>
          <h3 className="font-display font-black text-xl">{p.name}</h3></div>
        <div className={`text-sm mt-1 ${dark ? "text-white/70" : "text-muted-foreground"}`}>{p.trucks}</div>
        <div className="mt-4 flex items-end gap-1">
          <span className="font-display font-black text-4xl" data-testid={`plan-price-${p.id}`}>${p.amount.toFixed(0)}</span>
          <span className={`pb-1 text-sm ${dark ? "text-white/70" : "text-muted-foreground"}`}>/month + tax</span>
        </div>
        <p className={`text-sm mt-2 ${dark ? "text-white/80" : "text-muted-foreground"}`}>{p.blurb}</p>
        <ul className="mt-4 space-y-1.5 text-sm flex-1">
          {FEATURES.map(f => <li key={f} className="flex gap-2"><Check size={16} weight="bold" className="text-accent shrink-0 mt-0.5"/>{f}</li>)}
        </ul>
        <div className="mt-5">{action(p, current)}</div>
      </div>;
    })}
  </div>;
}
